import {
  GiftCardTransactionListQuery,
  GiftCardTransactionsFragment,
} from '@/gql/generated';
import { InfiniteData } from '@tanstack/react-query';

export const normalizeTransaction = (
  data: GiftCardTransactionListQuery | undefined,
): GiftCardTransactionsFragment[] => {
  if (!data) return [];
  return data.transaction.map((item) => {
    return item as GiftCardTransactionsFragment;
  });
};

export const normalizeTransactionInfinite = (
  data: InfiniteData<GiftCardTransactionListQuery, unknown> | undefined,
): GiftCardTransactionsFragment[] => {
  const pages = data?.pages;
  if (!pages) return [];
  return pages.flatMap((page) => normalizeTransaction(page));
};
